import { render } from "./UploadAsset.vue?vue&type=template&id=78c38ede"
import script from "./UploadAsset.vue?vue&type=script&lang=js"
export * from "./UploadAsset.vue?vue&type=script&lang=js"

import "./UploadAsset.vue?vue&type=style&index=0&id=78c38ede&lang=css"

import exportComponent from "/home/forge/fortiuspro.onlinesolutionsltd.com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__